import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle
} from './dialog'
import { FcGoogle } from 'react-icons/fc'
import { signIn } from 'next-auth/react'
import { useState } from 'react'

export function LoginDialog({
  open = false,
  handleClose
}: {
  open: boolean
  handleClose: () => void
}) {
  const [email, setEmail] = useState('')
  const [emailSent, setEmailSent] = useState(false)

  if (emailSent) {
    return (
      <Dialog open={open} onOpenChange={() => handleClose()}>
        <DialogContent>
          <DialogTitle>Link Sent!</DialogTitle>
          <DialogDescription>
            Check your inbox for the log-in link we&apos;ve just emailed to you.
          </DialogDescription>
        </DialogContent>
      </Dialog>
    )
  }
  return (
    <Dialog open={open} onOpenChange={() => handleClose()}>
      <DialogContent>
        <DialogTitle>Log in to continue</DialogTitle>
        <button
          onClick={() => signIn('google')}
          className="flex py-2 rounded border gap-2 items-center justify-center"
        >
          <FcGoogle height={20} />
          Continue with Google
        </button>
        or
        <input
          value={email}
          onChange={e => setEmail(e.target.value)}
          name="email"
          type="email"
          placeholder="Email"
          className="leading-5 resize-none max-h-60 pl-4 pr-14  rounded-full hover:shadow-lg hover focus-visible:shadow-lg flex  w-full border border-input py-3 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-ring  disabled:cursor-not-allowed disabled:opacity-50"
        />
        <button
          type="submit"
          onClick={async () => {
            const result = await signIn('email', {
              email: email,
              redirect: false
            })
            if (result?.ok) {
              setEmailSent(true)
            }
          }}
          className="flex py-2 rounded border gap-2 items-center justify-center"
        >
          Log in
        </button>
      </DialogContent>
    </Dialog>
  )
}
